import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillOfLadingThumbnail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 66,
	height: 81,
	viewBox: "0 0 66 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_6311_41063)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M56.6208 3H9.37838C8.06484 3 7 4.06296 7 5.37419V67.7259C7 69.0371 8.06484 70.1001 9.37838 70.1001H56.6208C57.9344 70.1001 58.9992 69.0371 58.9992 67.7259V5.37419C58.9992 4.06296 57.9344 3 56.6208 3Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M56.6209 3.14844H9.37841C8.14697 3.14844 7.14868 4.14497 7.14868 5.37424V67.7259C7.14868 68.9552 8.14697 69.9517 9.37841 69.9517H56.6209C57.8523 69.9517 58.8506 68.9552 58.8506 67.7259V5.37424C58.8506 4.14497 57.8523 3.14844 56.6209 3.14844Z",
				fill: "white",
				stroke: "#D0D5DD",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.5634 39.5H13.4366C13.1955 39.5 13 39.7239 13 40C13 40.2761 13.1955 40.5 13.4366 40.5H51.5634C51.8045 40.5 52 40.2761 52 40C52 39.7239 51.8045 39.5 51.5634 39.5Z",
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.5634 10.5H13.4366C13.1955 10.5 13 10.7239 13 11C13 11.2761 13.1955 11.5 13.4366 11.5H51.5634C51.8045 11.5 52 11.2761 52 11C52 10.7239 51.8045 10.5 51.5634 10.5Z",
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.5634 42.5H13.4366C13.1955 42.5 13 42.7239 13 43C13 43.2761 13.1955 43.5 13.4366 43.5H51.5634C51.8045 43.5 52 43.2761 52 43C52 42.7239 51.8045 42.5 51.5634 42.5Z",
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.5634 45.5H13.4366C13.1955 45.5 13 45.7239 13 46C13 46.2761 13.1955 46.5 13.4366 46.5H51.5634C51.8045 46.5 52 46.2761 52 46C52 45.7239 51.8045 45.5 51.5634 45.5Z",
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.5634 48.5H13.4366C13.1955 48.5 13 48.7239 13 49C13 49.2761 13.1955 49.5 13.4366 49.5H51.5634C51.8045 49.5 52 49.2761 52 49C52 48.7239 51.8045 48.5 51.5634 48.5Z",
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.567 61.5H13.433C13.1939 61.5 13 61.7239 13 62C13 62.2761 13.1939 62.5 13.433 62.5H51.567C51.8061 62.5 52 62.2761 52 62C52 61.7239 51.8061 61.5 51.567 61.5Z",
			fill: "#A9B4B9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.9727,
			y: 12.9102,
			width: 18,
			height: 10,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.9727,
			y: 12.9102,
			width: 19,
			height: 12,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.9727,
			y: 26.9102,
			width: 19,
			height: 11,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.9727,
			y: 23.9102,
			width: 18,
			height: 6,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.9727,
			y: 30.9102,
			width: 18,
			height: 7,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12.9727,
			y: 51.9102,
			width: 19,
			height: 7,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 42.9727,
			y: 51.9102,
			width: 9,
			height: 7,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 32.9727,
			y: 51.9102,
			width: 9,
			height: 7,
			rx: 1,
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6311_41063",
			x: .898682,
			y: .898438,
			width: 64.2019,
			height: 79.3032,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6311_41063"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6311_41063",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgBillOfLadingThumbnail;
